import React, { useContext } from 'react';
import {
  Button,
  mergeClasses,
} from '@fluentui/react-components';

import {
  Drawer,
  DrawerHeader,
  DrawerHeaderTitle,
} from '@fluentui/react-drawer';

import { Dismiss24Regular } from '@fluentui/react-icons';

import { I18nContext } from '@bingads-webui-react/i18n-context';

import { I18n, MarginStyles } from './types';
import { useDialogContainerStyles } from './styles';

export const ToolsPanelContainer: React.FC<{
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
  overlayMargins?: MarginStyles;
}> = ({
  open, children, onClose, overlayMargins,
}) => {
  const i18n: I18n = useContext(I18nContext);
  const classes = useDialogContainerStyles();
  const panelStyle = {
    height: `calc(100vh - ${overlayMargins.marginTop}px)`,
    marginLeft: `${overlayMargins.marginLeft}px`,
  };
  const bodyStyle = {
    height: `calc(100% - ${overlayMargins.marginTop}px)`,
  };

  return (
    <Drawer
      className={mergeClasses('tools-dialog', classes.panelOffset, classes.surface)}
      open={open}
      onOpenChange={onClose}
      backdrop={{ className: classes.panelOffset, style: panelStyle }}
      style={panelStyle}
      // mountNode={document.querySelector('.provider')} // for local development
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={(
            <Button
              className="close-dialog-btn"
              icon={<Dismiss24Regular />}
              appearance="subtle"
              aria-label={i18n.getString(_TL_('Close'))}
              onClick={onClose}
            />
          )}
        >
          {i18n.getString(_TL_('Browse all tools'))}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <div className={classes.panelBody} style={bodyStyle}>
        {children}
      </div>
    </Drawer>
  );
};

ToolsPanelContainer.defaultProps = {
  overlayMargins: {
    marginLeft: '0',
    marginTop: '0',
  },
};
